var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6C19.1046 6 20 5.10457 20 4C20 2.89543 19.1046 2 18 2C16.8954 2 16 2.89543 16 4C16 4.2645 16.0513 4.51701 16.1446 4.74811C16.2502 4.90774 16.3471 5.07367 16.4348 5.24514C16.8012 5.70516 17.3662 6 18 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85539 4.74811C7.94865 4.51701 8 4.2645 8 4C8 2.89543 7.10457 2 6 2C4.89543 2 4 2.89543 4 4C4 5.10457 4.89543 6 6 6C6.63383 6 7.1988 5.70516 7.56523 5.24514C7.65286 5.07367 7.7498 4.90774 7.85539 4.74811Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9655 7C16.9883 7.1971 17 7.39734 17 7.6C17 8.98006 16.4567 10.2482 15.5663 11.1747C15.7228 11.2949 15.8884 11.4037 16.062 11.5H17.25C17.8288 11.5 18.3658 11.651 18.8299 11.9138C20.6408 11.5317 22 9.9246 22 8C22 7.44772 21.5523 7 21 7H16.9655Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.938 11.5H6.75C6.17125 11.5 5.6342 11.651 5.17014 11.9138C3.35924 11.5317 2 9.9246 2 8C2 7.44772 2.44772 7 3 7H7.03452C7.01171 7.1971 7 7.39734 7 7.6C7 8.98006 7.54327 10.2482 8.4337 11.1747C8.2772 11.2949 8.11156 11.4037 7.938 11.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.2C13.933 11.2 15.5 9.58822 15.5 7.6C15.5 5.61177 13.933 4 12 4C10.067 4 8.5 5.61177 8.5 7.6C8.5 9.58822 10.067 11.2 12 11.2Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.8C5 13.8059 5.7835 13 6.75 13H17.25C18.2165 13 19 13.8059 19 14.8C19 18.7764 15.866 22 12 22C8.13401 22 5 18.7764 5 14.8ZM11.25 16.25H9.5C9.08579 16.25 8.75 16.5858 8.75 17C8.75 17.4142 9.08579 17.75 9.5 17.75H11.25H12.75H14.5C14.9142 17.75 15.25 17.4142 15.25 17C15.25 16.5858 14.9142 16.25 14.5 16.25H12.75H11.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveGroup);
export default __webpack_public_path__ + "static/media/remove-group.ac4d62c3721dfc21abd61b63d3715e52.svg";
export { ForwardRef as ReactComponent };